export const submitMixin = {
  data() {
    return {
      formName: '',
    }
  },
  mounted() {
    // add event listener for enter key and submit form
    document.addEventListener('keyup', this.enterKeySubmit)
  },
  methods: {
    enterKeySubmit(event) {
      const hasActiveElement = this.$refs[this.formName].$el.contains(document.activeElement)
      if (event.keyCode === 13 && hasActiveElement) {
        this.submitForm(this.formName)
      }
    }
  }
}